export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 12;

  static addProduct(handle) {
    if (!handle || /^\d+$/.test(handle)) return;
    let viewed = this.getProducts();
    viewed = viewed.filter(h => h !== handle);
    viewed.unshift(handle);
    viewed = viewed.slice(0, this.#MAX_PRODUCTS);
    sessionStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
  }

  static getProducts() {
    return JSON.parse(sessionStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static clearProducts() {
    sessionStorage.removeItem(this.#STORAGE_KEY);
  }
}
